import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_inventory-hub-1442/artifacts/xyf6dc2s_logo-tzanetatos-horizontal.png';

const Footer = () => {
  return (
    <footer className="mt-20 border-t border-emerald-100 bg-[#e9f7e4]/60">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 py-8 sm:flex-row sm:px-6 lg:px-8">
        <img src={LOGO_URL} alt="Catálogo Tzanetatos" className="h-9 w-auto object-contain" />
        <p className="text-xs text-slate-500">
          Catálogo Tzanetatos {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
